import { useState, type ReactNode } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'

export function AppLayout({ children }: { children: ReactNode }) {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <div className="flex h-screen overflow-hidden
                    bg-gradient-to-br from-[#e8f4fb] via-[#eef5fb] to-[#f0f7fe]
                    dark:bg-gradient-to-br dark:from-[#0a1628] dark:via-[#0d1d35] dark:to-[#0a1525]
                    p-3 gap-3">
      <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />

      {mobileOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/40 md:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <div className="flex flex-col flex-1 overflow-hidden min-w-0
                      rounded-3xl
                      bg-white/65 dark:bg-slate-900/60
                      backdrop-blur-2xl
                      border border-white/60 dark:border-white/8
                      shadow-[0_24px_56px_rgba(7,102,152,0.07)]">
        <Header onMenuClick={() => setMobileOpen(true)} />
        <main className="flex-1 overflow-y-auto px-4 py-4 sm:px-6 sm:py-6">
          {children}
        </main>
      </div>
    </div>
  )
}
